const PHOTO_STORY = 'photo story';
const CINEMATIC_STORY = 'cinematic story';
const PHOTO_ILLUSTRATED_BOOK = 'photo-illustrated book';
const CINEMATIC_BOOK = 'cinematic book';
const FILM = 'film';
const AUDIO = 'text'; // text converted to audio by amazon
const AUDIO_BOOK = 'audiobook';


const READ_MODE = 'text';
const LISTEN_MODE = 'audio';
const WATCH_MODE = 'video';

export default {
  BASE_URL: "",
  CONTROLS_ANIMATION_TIME: 0.5,
  BOOK_TYPE_MODES: {
    [PHOTO_STORY]: [READ_MODE],
    [CINEMATIC_STORY]: [READ_MODE, WATCH_MODE],
    // [PHOTO_ILLUSTRATED_BOOK]: [READ_MODE, WATCH_MODE],
    [PHOTO_ILLUSTRATED_BOOK]: [READ_MODE, LISTEN_MODE, WATCH_MODE],
    // [CINEMATIC_BOOK]: [READ_MODE, WATCH_MODE],
    [CINEMATIC_BOOK]: [READ_MODE, LISTEN_MODE, WATCH_MODE],
    [FILM]: [WATCH_MODE],
    [AUDIO]: [LISTEN_MODE],
    [AUDIO_BOOK]: [LISTEN_MODE],
  },
  BOOK_TYPE_DEFAULT_MODES: {
    [PHOTO_STORY]: READ_MODE,
    [CINEMATIC_STORY]: WATCH_MODE,
    [PHOTO_ILLUSTRATED_BOOK]: WATCH_MODE,
    [CINEMATIC_BOOK]: WATCH_MODE,
    [FILM]: WATCH_MODE,
    [AUDIO]: [LISTEN_MODE],
    [AUDIO_BOOK]: [LISTEN_MODE],
  },
  BOOK_TYPES: {
    PHOTO_STORY,
    CINEMATIC_STORY,
    PHOTO_ILLUSTRATED_BOOK,
    CINEMATIC_BOOK,
    FILM,
    AUDIO,
    AUDIO_BOOK
  },
  VIEWER_MODES: {
    READ_MODE,
    LISTEN_MODE,
    WATCH_MODE,
  }
}


// WEBPACK FOOTER //
// ./src/config/common.config.js